/**
 * @var {ApiMiddleware}
 */
import { find } from 'lodash'

let api = {}

/**
 * Set root path for api
 * @param {ApiMiddleware} middlewareObject
 */
export const setUsersApiMiddleware = middlewareObject => {
    api = middlewareObject
}

export default () => ({
    state: {
        users: [],
        groupList: [],
    },
    getters: {
        users: state => state.users,
        userById: state => id => find(state.users, ['id', id]),
    },
    mutations: {
        setUsers(state, users) {
            state.users = users
        },
    },
    actions: {
        async usersLoad({ commit }) {
            const users = await api.get('/user?depth=2')
            commit('setUsers', users)
        },
        async verifyInviteCode({ commit }, inviteCode) {
            return api.get(`/company/?action=inviteVerify&code=${inviteCode}`)
                .then(response => {
                    return response
                })
        },
        async addAclToCompany(_, data) {
            return api.post(`/acl`, data)
        },
        async createUser(_, data) {
            return api.post(`/user/`, data)
        },
        async updateUser({ commit }, data) {
            return api.put(`/user/${data.id}`, data)
                .then(response => {
                    return response.data
                })
        },
        async deleteUser({ dispatch }, id) {
            await api.delete(`/user/${id}`)
            await dispatch('usersLoad')
        },
        async sendResetPassword(_, data) {
            // console.info(token, password)
            await api.put(`/passwordReset`, data)
        },
        async requestResetPassword(_, data) {
            await api.post(`/passwordReset`, data)
        }
    },
})
